import { CallAttemptsIcon } from '@forwardflow/assets/svg/CallAttemptsIcon'
import { useGetDashboardCommunication } from '@forwardflow/hooks/customHooks'
import { AgentType, TimePeriod } from '@forwardflow/types'
import { useSearchParams } from 'react-router-dom'

export const CallAttemptsCard = () => {
   const [searchParams] = useSearchParams()
   const timePeriod = searchParams.get('timePeriod') || 'allTime'
   const agentType = searchParams.get('agentType') || 'all'
   const {
      data: DashboardChartsLeadSource,
      isLoading: DashboardChartsLeadSourceLoading,
   } = useGetDashboardCommunication({
      timePeriod: timePeriod as TimePeriod,
      agentType: agentType as AgentType,
   })

   const callAttempts = DashboardChartsLeadSource?.callAttempts

   if (DashboardChartsLeadSourceLoading) {
      return (
         <div className="flex flex-col w-full h-full p-6 text-white shadow-lg bg-white/5 rounded-xl">
            <div>Loading...</div>
         </div>
      )
   }

   return (
      <div className="flex flex-col justify-center w-full h-full px-6 py-4 text-white shadow-lg bg-white/5 rounded-xl">
         {/* <div className="flex items-center gap-6 mb-auto h-14">
            <CallAttemptsIcon />
            <span className="font-medium">Call attempts / lead</span>
         </div> */}
         <div className="flex items-center justify-between">
            <div className="flex flex-col justify-between flex-1 py-5 border-r border-white/20">
               {/* <span className="text-base">Overall</span> */}
               <div className="flex items-center gap-2 mt-1">
                  <div className="mr-6 scale-90">
                     <CallAttemptsIcon />
                  </div>

                  <span className="text-2xl font-medium">
                     {callAttempts?.overall?.callsPerLead ?? '--'} Calls/Lead
                  </span>
                  <span
                     className={`text-sm font-semibold ${
                        callAttempts?.overall?.change?.isIncrement
                           ? 'text-[#00AB40]'
                           : 'text-[#FF5185]'
                     }`}
                  >
                     {callAttempts?.overall?.change?.isIncrement ? '+' : '-'}
                     {callAttempts?.overall?.change?.value ?? '--'}%
                  </span>
               </div>
            </div>
            <span className="w-[30%] text-right text-white/70">
               {callAttempts?.overall?.callsPerAppointment ?? '--'} Calls/Appt.
            </span>
         </div>
         {/* <hr className="my-3 border-t border-white/20" /> */}
         {/* <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
               <span className="text-base">New Leads</span>
               <div className="flex items-center gap-2">
                  <span className="font-semibold">
                     {callAttempts?.newLeads?.callsPerLead ?? '--'} Calls
                  </span>
                  <span
                     className={`text-sm font-medium ${
                        callAttempts?.newLeads?.change?.isIncrement
                           ? 'text-[#00AB40]'
                           : 'text-[#FF5185]'
                     }`}
                  >
                     {callAttempts?.newLeads?.change?.isIncrement ? '+' : '-'}
                     {callAttempts?.newLeads?.change?.value ?? '--'}%
                  </span>
               </div>
            </div>
            <hr className="my-3 border-t border-white/20" />
            <div className="flex items-center justify-between">
               <span className="text-base">Revive leads</span>
               <div className="flex items-center gap-2">
                  <span className="font-semibold">
                     {callAttempts?.reviveLeads?.callsPerLead ?? '--'} Calls
                  </span>
                  <span
                     className={`text-sm font-medium ${
                        callAttempts?.reviveLeads?.change?.isIncrement
                           ? 'text-[#00AB40]'
                           : 'text-[#FF5185]'
                     }`}
                  >
                     {callAttempts?.reviveLeads?.change?.isIncrement
                        ? '+'
                        : '-'}
                     {callAttempts?.reviveLeads?.change?.value ?? '--'}%
                  </span>
               </div>
            </div>
         </div> */}
      </div>
   )
}
